import { render, staticRenderFns } from "./wechatUserForm.vue?vue&type=template&id=938eb5ea&scoped=true"
import script from "./wechatUserForm.vue?vue&type=script&lang=js"
export * from "./wechatUserForm.vue?vue&type=script&lang=js"
import style0 from "./wechatUserForm.vue?vue&type=style&index=0&id=938eb5ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938eb5ea",
  null
  
)

export default component.exports